export interface ValidatedUser {
  id: string;
  email: string;
  username: string;
}

/**
 * Role enum for user.user_role_id, FK into the user_role table.
 * Fallback axis for permission checks when `is_admin` is false.
 * Values must match the seeded user_role rows (see migration 20260907075044_add_user_role_table).
 */
export enum USER_ROLE {
  STUDENT = 1,
  PROF = 2,
  SUPERUSER = 3,
}
